import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
   
}


export default new Vuex.Store({
    state: {
        navIndex:0
    },
    mutations: {
        setnavIndex(state, data) {
            state.navIndex = data;
          },
    },
    actions: {
    },
    modules: {
    },
})


// WEBPACK FOOTER //
// ./src/store/index.js